import React from 'react';
import Video from './Video/Video.jsx'
import SobrePlataforma from './SobrePlataforma/SobrePlataforma.jsx';
import Vantagens from './Vantagens/Vantagens.jsx';
import Clientes from './Clientes/Clientes.jsx';
import QuemSomos from './QuemSomos/QuemSomos.jsx';
import FormHome from './FormHome/FormHome.jsx';




const Home = () => {

    return (
        <>
            <div className="view-home">
                <Video></Video>
                <SobrePlataforma></SobrePlataforma>
                <Vantagens></Vantagens>
                {/* <Clientes></Clientes> */}
                <QuemSomos></QuemSomos>
                <FormHome></FormHome>
            </div>
        </>

    )
}

export default Home;